/* KUP Contact page behaviour. Modules are independently guarded. */
(function(){
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Live open/closed status + local clock ----------
     Hours are 24h HH:MM. A closing time earlier than the opening time means
     the venue runs past midnight. Read in the shop's timezone via Intl, not
     the visitor's, so someone abroad still sees the Chennai state. */
  function toMins(s){
    if(!s) return null;
    var b = String(s).split(':');
    if(b.length < 2) return null;
    var h = parseInt(b[0],10), m = parseInt(b[1],10);
    return (isNaN(h) || isNaN(m)) ? null : h*60 + m;
  }
  function nowMins(tz){
    var p = new Intl.DateTimeFormat('en-GB',{timeZone:tz,hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(new Date());
    var h = 0, m = 0;
    p.forEach(function(x){ if(x.type==='hour') h = +x.value; if(x.type==='minute') m = +x.value; });
    return h*60 + m;
  }
  function pretty(mins){
    var h = Math.floor(mins/60) % 24, m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if(h12 === 0) h12 = 12;
    return h12 + (m ? ':' + ('0'+m).slice(-2) : '') + ' ' + ap;
  }
  function statusFor(el){
    var tz = el.getAttribute('data-tz') || 'Asia/Kolkata';
    var open = toMins(el.getAttribute('data-open'));
    var close = toMins(el.getAttribute('data-close'));
    if(open === null || close === null) return;
    var now = nowMins(tz);
    var isOpen = (close > open) ? (now >= open && now < close) : (now >= open || now < close);
    el.setAttribute('data-open-now', isOpen ? 'true' : 'false');
    var label = el.querySelector('[data-status-label]');
    var until = el.querySelector('[data-status-until]');
    if(label) label.textContent = isOpen ? (el.getAttribute('data-label-open') || 'Open now') : (el.getAttribute('data-label-closed') || 'Closed');
    if(until) until.textContent = isOpen ? ('till ' + pretty(close)) : ('opens ' + pretty(open));
  }
  function clockFor(el){
    var tz = el.getAttribute('data-tz') || 'Asia/Kolkata';
    var t = new Intl.DateTimeFormat('en-GB',{timeZone:tz,hour:'numeric',minute:'2-digit',hour12:true}).format(new Date());
    var tpl = el.getAttribute('data-template') || 'It is {time} in Chennai.';
    el.textContent = tpl.replace('{time}', t.toUpperCase().replace(/\s*(AM|PM)/, ' $1').trim());
  }
  function tickAll(){
    [].slice.call(document.querySelectorAll('[data-kc-status]')).forEach(statusFor);
    [].slice.call(document.querySelectorAll('[data-kc-clock]')).forEach(clockFor);
  }
  function scheduleTick(){
    tickAll();
    setTimeout(scheduleTick, (60 - new Date().getSeconds())*1000 + 50);
  }

  /* ---------- Switchboard ----------
     Lanes marked "expand" open an accordion panel carrying a bio and a direct
     email. Lanes marked "form" scroll to the general form instead. */
  function switchboard(){
    var sec = document.querySelector('[data-kc-switchboard]');
    if(!sec || sec.dataset.kcBound === '1') return;
    sec.dataset.kcBound = '1';

    var form = document.querySelector('[data-kc-form-sec]');
    var lanes = [].slice.call(sec.querySelectorAll('[data-lane]'));

    function closeAll(except){
      lanes.forEach(function(l){
        if(l === except || l.getAttribute('data-action') !== 'expand') return;
        l.setAttribute('aria-expanded','false');
        var p = document.getElementById(l.getAttribute('aria-controls'));
        if(p) p.style.height = '0px';
      });
    }

    lanes.forEach(function(el){
      el.addEventListener('click', function(){
        if(el.getAttribute('data-action') === 'form'){
          closeAll(null);
          if(!form) return;
          var y = form.getBoundingClientRect().top + window.pageYOffset - 40;
          window.scrollTo({ top: Math.round(y), behavior: RM ? 'auto' : 'smooth' });
          var first = form.querySelector('input[type="text"]');
          if(first) setTimeout(function(){ first.focus({preventScroll:true}); }, RM ? 0 : 650);
          return;
        }
        var panel = document.getElementById(el.getAttribute('aria-controls'));
        if(!panel) return;
        var open = el.getAttribute('aria-expanded') === 'true';
        closeAll(el);
        if(open){
          el.setAttribute('aria-expanded','false');
          panel.style.height = '0px';
        } else {
          el.setAttribute('aria-expanded','true');
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        }
      });
    });

    window.addEventListener('resize', function(){
      lanes.forEach(function(l){
        if(l.getAttribute('aria-expanded') !== 'true') return;
        var p = document.getElementById(l.getAttribute('aria-controls'));
        if(p) p.style.height = p.firstElementChild.offsetHeight + 'px';
      });
    }, {passive:true});
  }

  /* ---------- Form: in-place submit + magnetic button ---------- */
  function contactForm(){
    var sec = document.querySelector('[data-kc-form-sec]');
    if(!sec) return;
    var form = sec.querySelector('form');
    if(!form || form.dataset.kcBound === '1') return;
    form.dataset.kcBound = '1';

    form.addEventListener('submit', function(e){
      if(!window.fetch || !window.FormData) return;   // native fallback
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if(btn) btn.disabled = true;
      fetch(form.action, { method:'POST', body:new FormData(form), headers:{'Accept':'text/html'} })
        .then(function(r){
          if(!r.ok) throw new Error('bad response');
          sec.classList.add('is-sent');
          var y = sec.getBoundingClientRect().top + window.pageYOffset - 60;
          window.scrollTo({ top: Math.round(y), behavior: RM ? 'auto' : 'smooth' });
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if(btn) btn.disabled = false; });
    });

    var btn = sec.querySelector('[data-magnetic]');
    if(btn && !RM && window.matchMedia('(hover:hover)').matches){
      btn.addEventListener('pointermove', function(e){
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width/2);
        var dy = e.clientY - (r.top + r.height/2);
        btn.style.transform = 'translate(' + (dx*0.22).toFixed(1) + 'px,' + (dy*0.28).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function(){ btn.style.transform = ''; });
    }
  }

  /* ---------- FAQ accordion ---------- */
  function faq(){
    var list = document.querySelector('[data-kc-faq]');
    if(!list || list.dataset.kcBound === '1') return;
    list.dataset.kcBound = '1';
    var qs = [].slice.call(list.querySelectorAll('[data-q]'));
    qs.forEach(function(q){
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      if(!panel) return;
      q.addEventListener('click', function(){
        var open = q.getAttribute('aria-expanded') === 'true';
        qs.forEach(function(o){
          var p = document.getElementById(o.getAttribute('aria-controls'));
          o.setAttribute('aria-expanded','false');
          if(p) p.style.height = '0px';
        });
        if(!open){
          q.setAttribute('aria-expanded','true');
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        }
      });
    });
    window.addEventListener('resize', function(){
      qs.forEach(function(q){
        if(q.getAttribute('aria-expanded') !== 'true') return;
        var p = document.getElementById(q.getAttribute('aria-controls'));
        if(p) p.style.height = p.firstElementChild.offsetHeight + 'px';
      });
    }, {passive:true});
  }

  /* ---------- Location image settle ---------- */
  function locations(){
    var els = [].slice.call(document.querySelectorAll('.kc-loc'));
    if(!els.length) return;
    if(RM || !('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(en){
      en.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('in'); });
    },{threshold:.18});
    els.forEach(function(e){ io.observe(e); });
  }

  function boot(){ scheduleTick(); switchboard(); contactForm(); faq(); locations(); }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function(){
    tickAll(); switchboard(); contactForm(); faq(); locations();
  });
})();
